import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, Navigate, Outlet } from "react-router-dom";
//import { getLoggedUserToken, getLoggedUser, getRefreshToken } from "../../store/auth";
import { styled } from "@mui/material/styles";
import Menu from "../../Components/HeaderNavigation/Menu";
import { Box, Typography } from "@mui/material";
import PageBreadcrumbs from "../common/pageBreadcrumbs/pageBreadcrumbs";
import { useMediaQuery } from "@mui/material";
import { myGlobalTheme } from "../../Styled/style";
import { loggedInUserDataSelector, startRefreshAccessToken } from "../../Store/UsersAccount/userAccount.slice.selector";
const drawerWidth = 240;

const Main = styled("main")(({ theme, open, isItBelowTabletView }) => {
  return isItBelowTabletView
    ? { flexGrow: 1, padding: theme.spacing(3) }
    : {
      flexGrow: 1,
      marginLeft: 65,
      padding: theme.spacing(3),
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),

      ...(open && {
        transition: theme.transitions.create("margin", {
          easing: theme.transitions.easing.easeOut,
          duration: theme.transitions.duration.enteringScreen,
        }),
        marginLeft: `${drawerWidth}px`,
      }),
    };
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),

  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
}));

const RequireAuth = ({ userData }) => {
  const dispatch = useDispatch()
  const [open, setOpen] = useState(false);
  const mathes = useMediaQuery(myGlobalTheme.breakpoints.down("tablet"));
  const location = useLocation();
  const loggedInUserData = useSelector(loggedInUserDataSelector);
  let a = 0;
  useEffect(() => {
    a++
    if (!loggedInUserData?.email && a === 1) dispatch(startRefreshAccessToken());
  }, [loggedInUserData]);

  return loggedInUserData?.email ? (
    <>
      <Main
        open={open}
        sx={{ bgcolor: "rgb(243,244,250)", minHeight: "100vh" }}
        isItBelowTabletView={mathes}
      >
        <Menu
          open={open}
          setOpen={setOpen}
          userData={userData}
          isItBelowTabletView={mathes}
        />
        <DrawerHeader />

        <PageBreadcrumbs />

        <Outlet />
        <Box sx={{ marginTop: "1.5rem" }}>
          <Typography variant="caption" display="block" gutterBottom>
            © 2022 DDRMS
          </Typography>
        </Box>
      </Main>
    </>
  ) : (
    <Navigate to="/login" state={{ from: location }} replace />
  );
};

export default RequireAuth;
